// src/services/scroll-lock.service.ts
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ScrollLockService {
  private lockCount = 0;

  lock(): void {
    this.lockCount++;
    console.log('Scroll locked, count:', this.lockCount);
    if (this.lockCount === 1) {
      // Only add class if this is the first lock request
      document.body.classList.add("p-overflow-hidden");
    }
  }

  unlock(): void {
    if (this.lockCount > 0) {
      this.lockCount--;
      console.log('Scroll unlocked, count:', this.lockCount);
      if (this.lockCount === 0) {
        // Only remove class if no components are requesting a lock
        setTimeout(() => {
          document.body.classList.remove("p-overflow-hidden");
        }, 100);
      }
    }
  }

  // Force unlock everything (emergency cleanup)
  reset(): void {
    this.lockCount = 0;
    console.log('Scroll reset');
    document.body.classList.remove("p-overflow-hidden");
  }
}
